const {jQuery: $} = window;

import Utils from "./utils.class";
import MarketoValidator from "./MarketoValidator.class";
import MarketoPlugin from "./MarketoPlugin.class";

export default class Marketo {
    #id;
    #domain;
    #cmp;
    #marketoLoaded = false;
    #options;
    #plugins = [];

    constructor(id, domain, cmp = false, options = {bannedDomains: [], freeDomains: [], autoValues: [], floatLabels: false}) {
        this.#id = id;
        this.#domain = domain;
        this.#cmp = cmp;
        this.#options = options;

        if(this.cmp) {
            $(window).one(this.cmp.events.consent.marketing, () => this.load());
        } else {
            $(window).on("load", () => this.load());
        }

        Utils.log("Registered: Marketo (" + id + ")");
    }

    load() {
        // Async load marketo forms and set up global email validation rules

        Utils.log("Loading Marketo...");
        const self = this;

        if (!this.#marketoLoaded) {
            this.#marketoLoaded = true;

            $.getScript("https://" + this.domain + "/js/forms2/js/forms2.js", () => {
                Utils.log("Loaded Forms2.js");

                MktoForms2.whenReady((form) => {
                    Utils.log("Marketo Ready");
                    if(self.options.floatLables) this.#floatLabel('.mktoFormRow .mktoField');
                    let urlParams = Utils.URLSearchParams;
                    const values = form.getValues();

                    // Keep any value already filled in (ex: from the UTM cookies by the form loaded handler), since
                    // whenReady can run after it and the URL has no UTMs when they come from cookies.
                    const utm = (field, param) => urlParams.get(param) || values[field] || "";

                    form._emailValidation = false;

                    form.addHiddenFields({
                        "utm_campaign": utm("utm_campaign", "utm_campaign"),
                        "utm_medium": utm("utm_medium", "utm_medium"),
                        "utm_source": utm("utm_source", "utm_source"),
                        "utm_content": utm("utm_content", "utm_content"),
                        "utm_campaign__c": utm("utm_campaign__c", "utm_campaign"),
                        "utm_medium__c": utm("utm_medium__c", "utm_medium"),
                        "utm_source__c": utm("utm_source__c", "utm_source"),
                        "utm_content__c": utm("utm_content__c", "utm_content"),
                        "gCLIDValue": "",
                        "leadSourceMR": "",
                    });

                    try {
                        form.setValues({"gCLIDValue": ga.getAll()[0].get("clientId")});
                    } catch (e) {
                        Utils.log("Unable to set clientId");
                    }

                    form.getFormElem().find(".mktoEmailField").on('change', () => {
                        form._emailValidation = false;
                    });

                    form.getFormElem().find('.mktoButton').on('click', function () {
                        let $btn = $(this);
                        setTimeout(function () {
                            $btn.attr("disabled", "disabled");
                        }, 1);
                    });

                    form.onValidate((success) => {
                        Utils.log("Marketo Validation: ", success);

                        if (!success) {
                            // Restore access to the button after a few moments.
                            setTimeout(() => {
                                form.getFormElem().find('.mktoButton').removeAttr("disabled");
                            }, 3000);
                        }
                    });

                    form.onSubmit(() => {
                        let success = form.validate();

                        Utils.log("Running Custom Validation...");

                        success = MarketoValidator.runTasks(form, success);

                        Utils.log("Validation results: ", success ? "Success" : "Failed");

                        form.submittable(success);

                        if (!success) {
                            // Restore access to the button after a few moments.
                            setTimeout(function () {
                                form.getFormElem().find('.mktoButton').removeAttr("disabled");
                            }, 3000);
                        }

                        setTimeout(function () {
                            form.submittable(true);
                        }, 1);
                    });
                });

                MarketoValidator.registerTask("Default Validation", function ($) {
                    let email = this.vals().Email || this.vals().Email_Address_L__c;

                    if (email) {
                        if (!Utils.isEmailGood(self.#options.bannedDomains, email)) {
                            // Found competitor email, fake thank you message.
                            this.getFormElem().html("<p style='text-align: center;font-size: 100%;'>Thank you for your interest, you will hear from us soon.</p>");
                            return false;
                        } else if (!Utils.isEmailGood(self.#options.freeDomains, email)) {
                            let $emailEl = this.getFormElem().find(".mktoEmailField");

                            Utils.log("Email Error: Not business email.");

                            // Allow marketo errors to be displayed until the next time the field is clicked on (conflict with this.#neverbounce)
                            $emailEl.parent().addClass("show_errors").one("click", function () {
                                $(this).removeClass('show_errors');
                            });

                            this.showErrorMessage("Please enter a business email.", $emailEl);
                            return false;
                        }
                    }

                    return true;
                });

                this.#initPlugins();

                const $forms = $(".mktoForm");

                if($forms.length > 0){
                    $forms.each((i, el) => {
                        const $el = $(el);
                        const $settings = $el.find("script[type='application/json']");
                        const data = JSON.parse($settings.text());

                        $settings.detach();

                        Utils.log($el, data);

                        MktoForms2.loadForm(`//${this.domain}`, this.id, $el.data("id"), (form) => {
                            Utils.log("Form loaded: ", $el.data("id"));
                            $(window).trigger("kmdg_marketo_form_loaded", [form, data, this]);
                        });
                    });
                } else {
                    Utils.log("No Marketo forms detected.");
                }

                Utils.log("Marketo Fully loaded.");
                $(window).trigger("kmdg_marketo_ready", [this, MarketoValidator]);
            });
        } else {
            Utils.log("Marketo already loaded.")
        }
    }

    #floatLabel(inputType) {
        $(inputType).each(function () {
            let $this = $(this);
            $this.attr('placeholder', '');
            if (!$this.children().first().val()) {
                $this.children().first().text('');
            }
            const $parent = $this.closest('.mktoFieldWrap');
            if ($this.attr('type') === 'checkbox') {
                $parent.addClass('active');
                $parent.addClass('override');
            }
        });

        $(document).on('change', function () {
            $(inputType).each(function () {
                let $this = $(this);
                $this.attr('placeholder', '');
                if (!$this.children().first().val()) {
                    $this.children().first().text('');
                }
                const $parent = $this.closest('.mktoFieldWrap');
                if ($this.attr('type') === 'checkbox') {
                    $parent.addClass('active');
                    $parent.addClass('override');
                }
            });
        })

        $(document).on("focus", inputType, (function () {
                let $this = $(this);
                const $parent = $this.closest('.mktoFieldWrap');
                if ($this.attr('name') !== 'optinconsent') {
                    $parent.addClass('active').addClass('focus');
                    $this.addClass('focused');
                }
            }
        ));

        $(document).on("blur", inputType, (function () {
            let $this = $(this);
            const $parent = $this.closest('.mktoFieldWrap');
            $parent.removeClass('focus')
            $this.removeClass('focused');
            if (($this.val() === '' || $this.val() === 'blank') && ($this.attr('type') !== 'checkbox')) {
                $parent.removeClass('active')
            }
        }));
    }

    #initPlugins() {
        // Wait for signal that marketo is ready before loading plugins

        Utils.log("Loading Form Plugins...");

        for (let i in this.#plugins) {
            Utils.log("Loading Mkto plugin:", this.#plugins[i].name, this.#plugins[i].class);

            if (this.#plugins[i].class.marketoIntegration) {
                this.#plugins[i].class.marketoIntegration();
            } else {
                Utils.log("Error! Invalid plugin.");
            }
        }
    }

    registerPlugin(name, instance) {
        Utils.log("Registered Mkto plugin:", name);

        this.#plugins.push({
            name: name,
            class: instance
        });
    }

    get domain() {
        return this.#domain;
    }

    get id() {
        return this.#id;
    }

    get cmp() {
        return this.#cmp;
    }

    get options() {
        return this.#options;
    }
}